module.exports = __webpack_public_path__ + "media/application/images/icons/wiki-third-level-branch-last-e8761e3cabbbd4b0269676ec9ded4fda.svg";